module.exports = __webpack_public_path__ + "app/principal/routing/routing-code-2rgTZS5A.html";